module.exports = __webpack_public_path__ + "a32aefde2cfdc50d6cc769c296a4fd07.png";